import { type FC } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Sidebar } from './sidebar.js';
import { GlobalHeader } from './header.js';
import { CommandPalette } from './command-palette.js';
import { TooltipProvider } from '../ui/tooltip.js';
import { WebSocketProvider } from '../../hooks/WebSocketContext.js';

export const Layout: FC = () => {
  const location = useLocation();

  return (
    <WebSocketProvider>
      <TooltipProvider delayDuration={200}>
        <div className="flex h-screen overflow-hidden bg-slate-950 text-slate-100">
          <Sidebar />
          <div className="flex flex-1 flex-col overflow-hidden">
            <GlobalHeader currentPath={location.pathname} />
            <main className="flex-1 overflow-y-auto">
              <Outlet />
            </main>
          </div>
          <CommandPalette />
        </div>
      </TooltipProvider>
    </WebSocketProvider>
  );
};
